var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "matdate", class: { "after-16": !_vm.$media.xl } },
    [
      _c("div", { staticClass: "insety-16" }, [
        _c("label", { staticClass: "bold bond-title fg70" }, [
          _vm._v(_vm._s(_vm.$t("currency"))),
        ]),
      ]),
      _c("ib-dropdown", {
        staticClass: "inset-8 bondsearch-currency outset-0",
        attrs: { width: "15ch", name: "currency", data: _vm.avaiCurrencies },
        on: { change: _vm.selectCurrency },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }